import PrivateRoute from 'utils/privateRoute';
import ExecutiveSummary from 'components/DataEstate/ExecutiveSummary';
import governance from 'components/DataEstate/governance';
import TopicOfTheMonth from 'components/DataEstate/TopicOfTheMonth';
import ExecutiveViewIncident from 'components/DataEstate/ExecutiveViewIncident';
import FinOpsMetrics from 'components/FineOps/FinOpsMetrics';
import FinOpsTabs from 'components/FinOpsExecutive/FinOpsTabs';
import ExecutiveViewChangeRequest from 'components/DataEstate/ExecutiveViewChangeRequest';
import ExecutiveViewServiceRequest from 'components/DataEstate/ExecutiveViewServiceRequest';
import FinOpsInsightsView from 'components/FineOps/FinOpsInsightsView';
import ExecutiveView2024OperationalMetrics from 'components/DataEstate/ExecutiveView2024OperationalMetrics';
import MIMReports from 'components/DataEstate/MIMReports';
import HappySignals from 'components/DataEstate/HappySignals';
import ProgramMetrics from 'components/DataEstate/ProgramMetrics';
import DMOMetrics from 'components/DataEstate/DMOMetrics';
import NPIDashboards from 'components/DataEstate/NPIDashboards';
import MBTDashboard from 'components/FineOps/FinOpsMBTDashboard';
import VendorManagement from 'components/DataEstate/VendorManagement';
import AIMLOpsMetrics from 'components/DataEstate/AIMLOpsMetrics';
import Overview from 'Pages/XOps/Summary/Overview';
import SectorMetrics from 'components/DataEstate/SectorMetrics';
import DandIRiskpage from 'components/DataEstate/DandIRiskpage';
import AppsProducts from 'components/DataEstate/AppsProducts';
import BAICenter from 'components/DataEstate/BAICenterDashboard';
import { useEffect } from 'react';


function ExternalRedirectKore({ to }: { to: string }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return <p>Redirecting you to Incident Insight Intelligence Work Notes Quality Hub...</p>;
}

function ExternalRedirectOps({ to }: { to: string }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return <p>Redirecting you to Operational - Incident Intelligence Center...</p>;
}

const DandAIOpsRoutes = [
	{
		key: 'D_AI_summary',
		route: '/D&AIXOps/Summary',
		component: (
			<PrivateRoute
				Component={ExecutiveSummary}
				restrictedRoles={[
					'Platform Operations Admin/SRE',
					'Data Operations Admin',
					'Data Operations User',
					'D&AI Executive User',
					'Program Executive'
				]}
			/>
		)
	},
	{
		key: 'D_AI_AppsProducts',
		route: '/D&AIXOps/segments/Apps-Products',
		component: (
			<PrivateRoute
				Component={AppsProducts}
				restrictedRoles={[
					'Platform Operations Admin/SRE',
					'Data Operations Admin',
					'Data Operations User',
					'D&AI Executive User',
					'Program Executive'
				]}
			/>
		)
	},
	{
		key: 'D_AI_governance',
		route: '/D&AIXOps/segments/governance',
		component: (
			<PrivateRoute
				Component={governance} // This component is being rendered
				restrictedRoles={[
					'Platform Operations Admin/SRE',
					'Data Operations Admin',
					'Data Operations User',
					'D&AI Executive User',
					'Program Executive'
				]} />
		)
	},

	{
		key: 'D_AI_riskpage', // <-- New unique key
		route: '/D&AIXOps/misc/riskpage', // <-- Your new path from the header
		component: (
			<PrivateRoute
				Component={DandIRiskpage} // <-- Your new component
				restrictedRoles={[
					'Platform Operations Admin/SRE',
					'Data Operations Admin',
					'Data Operations User',
					'D&AI Executive User',
					'Program Executive'
				]}
			/>
		)
	},
	{
		key: 'D_AI_topicofthemonth',
		route: '/D&AIXOps/misc/topicOfTheMonth',
		component: (
			<PrivateRoute
				Component={TopicOfTheMonth}
				restrictedRoles={[
					'Platform Operations Admin/SRE',
					'Data Operations Admin',
					'Data Operations User',
					'D&AI Executive User',
					'Program Executive'
				]}
			/>
		)
	},
	{
		key: 'D_AI_mimReports',
		route: '/D&AIXOps/itsm/MIMReports',
		component: (
			<PrivateRoute
				Component={MIMReports}
				restrictedRoles={[
					'Platform Operations Admin/SRE',
					'Data Operations Admin',
					'Data Operations User',
					'D&AI Executive User',
					'Program Executive'
				]}
			/>
		)
	},
	{
		key: 'D_AI_sectorMetrics',
		route: '/D&AIXOps/segments/SectorMetrics',
		component: (
			<PrivateRoute
				Component={SectorMetrics}
				restrictedRoles={[
					'Platform Operations Admin/SRE',
					'Data Operations Admin',
					'Data Operations User',
					'D&AI Executive User',
					'Program Executive'
				]}
			/>
		)
	},
	{
		key: 'D_AI_HappySignals',
		route: '/D&AIXOps/experience/HappySignals',
		component: (
			<PrivateRoute
				Component={HappySignals}
				restrictedRoles={[
					'Platform Operations Admin/SRE',
					'Data Operations Admin',
					'Data Operations User',
					'D&AI Executive User',
					'Program Executive'
				]}
			/>
		)
	},
	{
		key: 'D_AI_pipelineMatrics',
		route: '/D&AIXOps/segments/capability/pipelineMatrics',
		component: (
			<PrivateRoute
				Component={ProgramMetrics}
				componentProps={{ metricsType: "Pipeline", technologyLabel: "Technology", chartLabel: "Technologies", showSectorFilter: true }}
				restrictedRoles={[
					'Platform Operations Admin/SRE',
					'Data Operations Admin',
					'Data Operations User',
					'D&AI Executive User',
					'Program Executive'
				]}
			/>
		)
	},
	{
		key: 'D_AI_integration-ops-Matrics',
		route: '/D&AIXOps/segments/capability/integration-ops',
		component: (
			<PrivateRoute
				Component={ProgramMetrics}
				componentProps={{ metricsType: "Integration Ops", technologyLabel: "Technology", chartLabel: "Technologies", showSectorFilter: true }}
				restrictedRoles={[
					'Platform Operations Admin/SRE',
					'Data Operations Admin',
					'Data Operations User',
					'D&AI Executive User',
					'Program Executive'
				]}
			/>
		)
	},
	{
		key: 'D_AI_sector-data-lake-Matrics',
		route: '/D&AIXOps/segments/capability/sector-data-lake',
		component: (
			<PrivateRoute
				Component={ProgramMetrics}
				componentProps={{ metricsType: "Sector Data Lake", technologyLabel: "Technology", chartLabel: "Technologies", showSectorFilter: true }}
				restrictedRoles={[
					'Platform Operations Admin/SRE',
					'Data Operations Admin',
					'Data Operations User',
					'D&AI Executive User',
					'Program Executive'
				]}
			/>
		)
	},
	{
		key: 'D_AI_platformOpsMatrics',
		route: '/D&AIXOps/segments/capability/platformOpsMatrics',
		component: (
			<PrivateRoute
				Component={ProgramMetrics}
				componentProps={{ metricsType: "Platform", technologyLabel: "Technology", chartLabel: "Platforms", showSectorFilter: true, xopsType: "Platform Ops Metrics" }}
				restrictedRoles={[
					'Platform Operations Admin/SRE',
					'Data Operations Admin',
					'Data Operations User',
					'D&AI Executive User',
					'Program Executive'
				]}
			/>
		)
	},
	{
		key: 'D_AI_programMetrics',
		route: '/D&AIXOps/segments/programMetrics',
		component: (
			<PrivateRoute
				Component={ProgramMetrics}
				componentProps={{ metricsType: "Program", technologyLabel: "Program", chartLabel: "Programs", showSectorFilter: true }}
				restrictedRoles={[
					'Platform Operations Admin/SRE',
					'Data Operations Admin',
					'Data Operations User',
					'D&AI Executive User',
					'Program Executive'
				]}
			/>
		)
	},
	{
		key: 'D_AI_execview2024OperationalMetrics',
		route: '/D&AIXOps/executiveView/2024OperationalMetrics',
		component: (
			<PrivateRoute
				Component={ExecutiveView2024OperationalMetrics}
				restrictedRoles={[
					'Platform Operations Admin/SRE',
					'Data Operations Admin',
					'Data Operations User',
					'D&AI Executive User',
					'Program Executive'
				]}
			/>
		)
	},
	{
		key: 'D_AI_execviewIns',
		route: '/D&AIXOps/executiveView/Incidents',
		component: (
			<PrivateRoute
				Component={ExecutiveViewIncident}
				restrictedRoles={[
					'Platform Operations Admin/SRE',
					'Data Operations Admin',
					'Data Operations User',
					'D&AI Executive User',
					'Program Executive'
				]}
			/>
		)
	},
	{
		key: 'D_AI_execviewCRs',
		route: '/D&AIXOps/executiveView/ChangeRequests',
		component: (
			<PrivateRoute
				Component={ExecutiveViewChangeRequest}
				restrictedRoles={[
					'Platform Operations Admin/SRE',
					'Data Operations Admin',
					'Data Operations User',
					'D&AI Executive User',
					'Program Executive'
				]}
			/>
		)
	},
	{
		key: 'D_AI_execviewSRs',
		route: '/D&AIXOps/executiveView/ServiceRequests',
		component: (
			<PrivateRoute
				Component={ExecutiveViewServiceRequest}
				restrictedRoles={[
					'Platform Operations Admin/SRE',
					'Data Operations Admin',
					'Data Operations User',
					'D&AI Executive User',
					'Program Executive'
				]}
			/>
		)
	},
	{
		key: 'D_AI_BAICenter',
		route: '/D&AIXOps/service/BAICenter',
		component: (
			<PrivateRoute
				Component={BAICenter}
				restrictedRoles={[
					'Platform Operations Admin/SRE',
					'Data Operations Admin',
					'Data Operations User',
					'Program Executive'
				]}
			/>
		)
	},
	{
		key: 'D_AI_KOREIHub',
		route: '/D&AIXOps/service/KOREIHub',
		component: (
			<PrivateRoute
				Component={() => <ExternalRedirectKore to="https://pepwise.dev.mypepsico.com/kore" />}
				restrictedRoles={[
					'Platform Operations Admin/SRE',
					'Data Operations Admin',
					'Data Operations User',
					'Program Executive'
				]}
			/>
		)
	},
	{
		key: 'D_AI_OPSICenter',
		route: '/D&AIXOps/service/OPSICenter',
		component: (
			<PrivateRoute
				Component={() => <ExternalRedirectOps to="https://pepwise.dev.mypepsico.com/incidentinsight" />}
				restrictedRoles={[
					'Platform Operations Admin/SRE',
					'Data Operations Admin',
					'Data Operations User',
					'Program Executive'
				]}
			/>
		)
	},
	{
		key: 'D_AI_DMOMetrics',
		route: '/D&AIXOps/segments/capability/DMOMetrics',
		component: (
			<PrivateRoute
				Component={DMOMetrics}
				restrictedRoles={[
					'Platform Operations Admin/SRE',
					'Data Operations Admin',
					'Data Operations User',
					'D&AI Executive User',
					'Program Executive'
				]}
			/>
		)
	},
	{
		key: 'D_AI_finopsMetrics',
		route: '/finops/executive',
		component: (
			<PrivateRoute
				Component={FinOpsTabs}
				restrictedRoles={[
					'Platform Operations Admin/SRE',
					'Data Operations Admin',
					'Data Operations User',
				]}
			/>
		)
	},
	{
		key: 'D_AI_finopsMetrics',
		route: '/D&AIXOps/finopsMetrics/MBT',
		component: (
			<PrivateRoute
				Component={MBTDashboard}
				restrictedRoles={[
					'Platform Operations Admin/SRE',
					'Data Operations Admin',
					'Data Operations User',
					'D&AI Executive User',
					'Program Executive'
				]}
			/>
		)
	},
	{
		key: 'D_AI_finopsviewInsights',
		route: '/D&AIXOps/finopsMetrics/insightView',
		component: (
			<PrivateRoute
				Component={FinOpsInsightsView}
				restrictedRoles={[
					'Platform Operations Admin/SRE',
					'Data Operations Admin',
					'Data Operations User',
					'D&AI Executive User',
					'Program Executive'
				]}
			/>
		)
	},
	{
		key: 'D_AI_DepartmentLevelMetrics',
		route: '/D&AIXOps/segments/capability/DepartmentLevelMetrics',
		component: (
			<PrivateRoute
				Component={ProgramMetrics}
				componentProps={{ metricsType: "BI Ops", technologyLabel: "Technology", chartLabel: "Applications" }}
				restrictedRoles={[
					'Platform Operations Admin/SRE',
					'Data Operations Admin',
					'Data Operations User',
					'D&AI Executive User',
					'Program Executive'
				]}
			/>
		)
	},
	{
		key: 'D_AI_AIMLMetrics',
		route: '/D&AIXOps/segments/capability/AIMLMetrics',
		component: (
			<PrivateRoute
				Component={AIMLOpsMetrics}
				componentProps={{ metricsType: "AI/ML Ops", technologyLabel: "Technology", chartLabel: "Technologies" }}
				restrictedRoles={[
					'Platform Operations Admin/SRE',
					'Data Operations Admin',
					'Data Operations User',
					'D&AI Executive User',
					'Program Executive'
				]}
			/>
		)
	},
	{
		key: 'D_AI_DeptMetrics',
		route: '/D&AIXOps/segments/DepartmentMetrics',
		component: (
			<PrivateRoute
				Component={ProgramMetrics}
				componentProps={{ metricsType: "Department", technologyLabel: "Department", chartLabel: "Departments", showSectorFilter: true }}
				restrictedRoles={[
					'Platform Operations Admin/SRE',
					'Data Operations Admin',
					'Data Operations User',
					'D&AI Executive User',
					'Program Executive'
				]}
			/>
		)
	},
	{
		key: 'D_AI_npidashboards',
		route: '/D&AIXOps/misc/npiDashboards',
		component: (
			<PrivateRoute
				Component={NPIDashboards}
				restrictedRoles={[
					'Platform Operations Admin/SRE',
					'Data Operations Admin',
					'Data Operations User',
					'D&AI Executive User',
					'Program Executive'
				]}
			/>
		)
	},
	{
		key: 'D_AI_vendormanagement',
		route: '/D&AIXOps/misc/vendorManagement',
		component: (
			<PrivateRoute
				Component={VendorManagement}
				restrictedRoles={[
					'Platform Operations Admin/SRE',
					'Data Operations Admin',
					'Data Operations User',
					'D&AI Executive User',
					'Program Executive'
				]}
			/>
		)
	},
	// Summary
	{
		key: 'D_AI_summary_overview',
		route: '/DAIXOps/summary/overview',
		component: (
			<PrivateRoute
				Component={Overview}
				restrictedRoles={[
					'Platform Operations Admin/SRE',
					'Data Operations Admin',
					'Data Operations User',
					'D&AI Executive User',
					'Program Executive'
				]}
			/>
		)
	},

];

export default DandAIOpsRoutes;
